import React from 'react';

import { makeStyles } from '@material-ui/core';
import GridLayout from '../../../../../components/GridLayout';
import WidgetRenderer from '../../../../shared/Perspectives/Renderers/WidgetRenderer';

const useStyles = makeStyles(() => ({
  widget: {
    cursor: 'pointer !important',
    '& .ql-editor': {
      cursor: 'pointer !important',
      padding: 0
    },
  },
  modal: {
    position: 'absolute',
  }
}));

const PerspectiveEditor = ({
  widgets,
  isDragging,
  onDragStart,
  onDragStop,
  onDrop,
  onResizeStop,
  selectWidget,
  openModal,
  widgetProps,
  fullHeight,
  autoSize
}: any) => {
  const classes = useStyles();
  return (
    <GridLayout
      isDragging={isDragging}
      onDragStart={onDragStart}
      onDragStop={onDragStop}
      onDrop={onDrop}
      isDroppable
      autoSize={autoSize}
      fullHeight={fullHeight}
      // droppingWidgetType={localStorage.getItem(WIDGET_TYPE)}
      onResizeStop={onResizeStop}
      widgets={widgets}
      renderWidget={(_widget: any) => (
        <div
          onClick={() => selectWidget(_widget.id)}
          key={_widget.id}
          className={classes.widget}
        >
          <WidgetRenderer
            widget={_widget}
            openModal={openModal}
            editMode
            {...widgetProps}
          />
        </div>
      )}
    />
  );
};

export default PerspectiveEditor;
